var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditLeftFacedOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.50087 4.94507L4.44507 4.00087L10.6645 10.2203V11.1645H9.7203L3.50087 4.94507ZM2.55667 4.00087L1.61248 3.05667L2.55667 2.11247L3.50087 3.05667L2.55667 4.00087ZM9.1674 12.5H12V9.66673L3.02877 0.695508C2.90355 0.570324 2.73374 0.5 2.55667 0.5C2.37961 0.5 2.2098 0.570324 2.08457 0.695508L0.19551 2.58457C0.0703259 2.7098 9.53674e-07 2.87961 9.53674e-07 3.05667C9.53674e-07 3.23374 0.0703259 3.40355 0.19551 3.52877L9.16674 12.5H9.1674Z",
    fill: "#63658E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLeftFacedOutlined);
export default __webpack_public_path__ + "static/media/editLeftFacedOutlined.7876ebdf0bb04a8b04b89f0dc61bad95.svg";
export { ForwardRef as ReactComponent };